import { render, staticRenderFns } from "./TradeContract.vue?vue&type=template&id=8d940a06&scoped=true&"
import script from "./TradeContract.vue?vue&type=script&lang=js&"
export * from "./TradeContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d940a06",
  null
  
)

export default component.exports